// extracted by mini-css-extract-plugin
export default {"receipt":"customer-form-send-file_receipt__Kppi0","email":"customer-form-send-file_email__7gR18","modalContainer":"customer-form-send-file_modalContainer__TIaY4"};